import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { netAmount } from '@/types/MultiPayoutTypes';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
let PayoutFormStep = class PayoutFormStep extends Vue {
    value;
    rows = [];
    headers = [
        { text: '', value: 'confirmed', sortable: false, width: '50px' },
        { text: 'Instruktor', value: 'instructorName', sortable: false, width: '250px' },
        { text: 'Číslo účtu', value: 'bankAccount', sortable: false },
        { text: 'Částka', value: 'amount', sortable: false, width: '120px' },
        { text: 'Daň', value: 'tax', sortable: false, width: '120px' },
        { text: 'Čistá částka', value: 'net', sortable: false },
        { text: 'Zůstatek', value: 'balance', sortable: false },
        { text: 'Zůstatek po', value: 'balanceAfter', sortable: false },
        { text: '', value: 'action', sortable: false, width: '50px' },
    ];
    netAmount = netAmount;
    amountRules = [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.POSITIVE_NUMBER];
    taxRules = [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.UNSIGNED_NUMBER];
    created() {
        this.rows = this.value.length > 0
            ? this.value.map(r => ({ ...r }))
            : [];
    }
    onValueChange(val) {
        this.rows = val.map(r => ({ ...r }));
    }
    get instructors() {
        const active = this.$store.getters['instructor/active'];
        return active.map(i => ({
            id: i.id,
            label: `${i.data.surname} ${i.data.name}`,
        }));
    }
    get isValid() {
        return this.rows.length > 0 && this.rows.every(row => row.instructorId &&
            row.amount > 0 &&
            row.tax >= 0);
    }
    onInstructorChange(row) {
        const active = this.$store.getters['instructor/active'];
        const instructor = active.find(i => i.id === row.instructorId);
        if (instructor) {
            row.instructorName = `${instructor.data.surname} ${instructor.data.name}`;
            row.bankAccount = instructor.data.bankAccount || '';
            if (instructor.data.paysTaxes && row.amount > 0) {
                row.tax = Math.round(row.amount * 0.15 * 100) / 100;
            }
            else {
                row.tax = 0;
            }
        }
    }
    addRow() {
        this.rows.push({
            instructorId: '',
            instructorName: '',
            bankAccount: '',
            amount: 0,
            tax: 0,
            confirmed: false,
        });
    }
    getInstructorBalance(instructorId) {
        const active = this.$store.getters['instructor/active'];
        const instructor = active.find(i => i.id === instructorId);
        return instructor ? instructor.data.balance : 0;
    }
    formatCurrency(value) {
        return value.toFixed(2);
    }
    async removeRow(index) {
        if (!(await ConfirmDialog.open('Odebrání řádku', 'Opravdu chcete odebrat tento řádek?'))) {
            return;
        }
        this.rows.splice(index, 1);
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], PayoutFormStep.prototype, "value", void 0);
__decorate([
    Watch('value')
], PayoutFormStep.prototype, "onValueChange", null);
PayoutFormStep = __decorate([
    Component
], PayoutFormStep);
export default PayoutFormStep;
